import {palette} from '@anywhere-expert/colors';

export const defaultEmoji: string = '📄';
export const CategoriesColors: string[] = Object.values(palette.categorical);

export const CANNED_MESSAGE_SOURCE_MANUAL = 'Manual';
export const CANNED_MESSAGE_SOURCE_AUTOMATIC = 'Automatic';
